import React from "react";
import ParaplanningInputField from "../components/ParaplanningInputField";
import ParaplanningDateField from "../components/ParaplanningDateField";
import ParaplanningSelectField from "../components/ParaplanningSelectField";
import "../../../css/Praplanning/ParaplanningFilters.css";
import { PARAPLANNING_ASSIGNED_TO_OPTIONS } from "../constants/paraplanningAssignedToOptions";

const CATALOG_OPTIONS = [
  {
    id: "mortgage_protection",
    value: "mortgage_protection",
    label: "Mortgage & Protection",
    name: "Mortgage & Protection",
  },
  {
    id: "financial_planning",
    value: "financial_planning",
    label: "Financial Planning",
    name: "Financial Planning",
  },
];

const STATUS_OPTIONS = [
  {
    id: "all",
    value: "all",
    label: "All statuses",
    name: "All statuses",
  },
  {
    id: "in_progress",
    value: "in_progress",
    label: "In Progress",
    name: "In Progress",
  },
  {
    id: "completed",
    value: "completed",
    label: "Completed",
    name: "Completed",
  },
  // {
  //   id: "cancelled",
  //   value: "cancelled",
  //   label: "Cancelled",
  //   name: "Cancelled",
  // },
  {
    id: "npw",
    value: "npw",
    label: "NPW",
    name: "NPW",
  }
];

const QUARTER_OPTIONS = [
  {
    id: "",
    value: "",
    label: "All quarters",
    name: "All quarters",
  },
  {
    id: "2026-Q1",
    value: "2026-Q1",
    label: "2026 Q1",
    name: "2026 Q1",
  },
  {
    id: "2026-Q2",
    value: "2026-Q2",
    label: "2026 Q2",
    name: "2026 Q2",
  },
  {
    id: "2026-Q3",
    value: "2026-Q3",
    label: "2026 Q3",
    name: "2026 Q3",
  },
  {
    id: "2026-Q4",
    value: "2026-Q4",
    label: "2026 Q4",
    name: "2026 Q4",
  },
];

const ParaplanningFilters = ({ filters, setFilters }) => {
  const updateFilter = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <section className="ParaplanningFilters">
      <ParaplanningInputField
        label="Search"
        value={filters.search || ""}
        placeholder="Search adviser, client or case type"
        onChange={(value) => updateFilter("search", value)}
      />

      <ParaplanningSelectField
        value={filters.catalogId || ""}
        label="Category"
        placeholder="Select category"
        options={CATALOG_OPTIONS}
        onChange={(value) => updateFilter("catalogId", value)}
      />
      <ParaplanningSelectField
        value={filters.assignedTo || ""}
        placeholder="Select Staff Member"
        label="Assigned to"
        options={PARAPLANNING_ASSIGNED_TO_OPTIONS.map((option) => ({
          id: option.email,
          value: option.email,
          label: option.label,
          name: option.label,
          email: option.email,
        }))}
        onChange={(value) => updateFilter("assignedTo", value)}
      />

      <ParaplanningSelectField
        value={filters.status || "all"}
        label="Status"
        placeholder="Select status"
        options={STATUS_OPTIONS}
        onChange={(value) => updateFilter("status", value)}
      />

      <div className="ParaplanningFilters__Field">
        <ParaplanningDateField
          label="Start Date"
          value={filters.startDate || ""}
          onChange={(value) => updateFilter("startDate", value)}
        />

        {/* {filters.startDate && (
          <button
            type="button"
            className="ParaplanningFilters__ClearField"
            onClick={() => updateFilter("startDate", "")}
          >
            Clear start date
          </button>
        )} */}
      </div>

      {/* <ParaplanningSelectField
        value={filters.quarterKey || ""}
        placeholder="Select quarter"
        options={QUARTER_OPTIONS}
        onChange={(value) => updateFilter("quarterKey", value)}
      /> */}

      {/* <label className="ParaplanningFilters__Checkbox">
        <input
          type="checkbox"
          checked={Boolean(filters.showArchived)}
          onChange={(event) =>
            updateFilter("showArchived", event.target.checked)
          }
        />
        <span>Show archived</span>
      </label> */}
    </section>
  );
};

export default ParaplanningFilters;
